module.exports = "/packs/images/svg/ireland/facilities/gift_shop~d81962b922fd20a757b36d416f83fa12.svg";